import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { TipoPratica } from '../../shared/models/pratiche';

@Injectable({
  providedIn: 'root'
})
export class TipoPraticaApiService {

  private baseUrl = `${environment.servicesPraticheUrl}/api/v1/__NO_COMUNE__/tipo_pratica`;

  setSlugComune(slug: string) {
    this.baseUrl = `${environment.servicesPraticheUrl}/api/v1/${slug}/tipo_pratica`;
  }

  constructor(private http: HttpClient) {}

  getAll(): Observable<TipoPratica[]> {
    return this.http.get<TipoPratica[]>(`${this.baseUrl}/public`);
  }

  getByCode(codiceTipoPratica: string): Observable<TipoPratica> {
    return this.http.get<TipoPratica>(`${this.baseUrl}/${codiceTipoPratica}/public`);
  }
}
